const EmbeddedSearch: React.FC<React.PropsWithChildren> = () => {
  return <div>Temp Embedded Search Page</div>
}

export default EmbeddedSearch
